module.exports = __webpack_public_path__ + "img/wechartCode.c58dfc14.jpg";